import QRCode from 'qrcode'

export async function generateQRCodeSvg(url) {
    const qrcode = await QRCode.toString(url, { 
      type: 'svg',
      width: 200,  // Smaller size (default is ~300-400)
      margin: 2,   // Reduce margin
    })
    return qrcode
}

export async function generateQRCodeDownloadUrl(url) {
    const downloadUrl = await QRCode.toDataURL(url, {
        width: 512,
        margin: 2,
    })
    return downloadUrl
}